export const telesalesPaymentRequestRoute = {
  path: '/checkout/init',
  component: 'ts-request-payment',
  componentName: 'Request Payment Page',
  theme: 'instaCred',
  template: 'telesales',
};

export const telesalesAppRoutes = [telesalesPaymentRequestRoute];



// WEBPACK FOOTER //
// ./alias/telesalesAppRoutes.js